import { z } from 'zod';

import { Option } from '../../types/Option';

const list = ['high-impedance-earthed-neutral', 'low-impedance-earthed-neutral'] as const;

type ACEarthingConfiguration = (typeof list)[number];

const options = [
    { value: 'high-impedance-earthed-neutral', label: 'High-impedance grounded neutral' },
    { value: 'low-impedance-earthed-neutral', label: 'Low-impedance grounded neutral' },
] as Option<ACEarthingConfiguration>[];

const validator = z.array(z.enum(list)).default([]);

export const ACEarthingConfigurations = {
    validator,
    options,
};
